import * as tslib_1 from "tslib";
import { env } from '@ivy/fts/envInfo/envInfo';
import { Component, Vue, Prop } from 'vue-property-decorator';
let CouponListPopup = class CouponListPopup extends Vue {
    constructor() {
        super(...arguments);
        this.coupons = [];
    }
    get popupVisible() {
        return this.visible;
    }
    get curCoupon() {
        return this.coupons.find(v => v.id === this.userCouponId);
    }
    get isSameCoupon() {
        return coupon => {
            return (this.userCouponId === coupon.id &&
                this.couponUserId === coupon.coupon_user_id);
        };
    }
    async created() {
        // await this.$store.login()
        await env.init();
        if (this.mode === 'select') {
            this.coupons = this.originCoupons;
        }
        else {
            this.getProcessingCoupons();
        }
    }
    async getProcessingCoupons() {
        let { data } = await this.$axios.get(`/api/goods/shop/search/coupon/getProcessingCouponByGoods`, {
            params: {
                spuId: this.product.spuId,
                offset: 0,
                limit: 10,
            },
        });
        this.coupons = data;
    }
    async acquireCoupon(coupon) {
        if (coupon.collected_num >= coupon.per_count) {
            return this.$Toast('领取数量已达上限了喔');
        }
        const { data } = await this.$axios.post(`/api/goods/shop/search/coupon/acquireCoupon`, {
            activityId: coupon.activity_id,
        });
        this.getProcessingCoupons();
        if (data.code) {
            return this.$Toast(data.message);
        }
        return this.$Toast('领取成功啦');
    }
    onCheck(coupon) {
        // 电商埋点-确认订单页点击选择优惠券
        if (this.from === 'orderConfirm') {
            this.uploadEvent.sendRecord('Click_ConfirmOrder_SelectCoupons', '', { ...this.uploadParmas, CouponsID: coupon.id }, [
                ['p1', 'SkuID'],
                ['p3', 'CouponsID'],
            ]);
        }
        if (this.userCouponId === coupon.id &&
            this.couponUserId === coupon.coupon_user_id) {
            this.hide({});
        }
        else {
            this.hide(coupon);
        }
    }
    hide(r) {
        this.close(r || {});
    }
};
tslib_1.__decorate([
    Prop()
], CouponListPopup.prototype, "visible", void 0);
tslib_1.__decorate([
    Prop()
], CouponListPopup.prototype, "close", void 0);
tslib_1.__decorate([
    Prop()
], CouponListPopup.prototype, "originCoupons", void 0);
tslib_1.__decorate([
    Prop()
], CouponListPopup.prototype, "mode", void 0);
tslib_1.__decorate([
    Prop()
], CouponListPopup.prototype, "userCouponId", void 0);
tslib_1.__decorate([
    Prop()
], CouponListPopup.prototype, "couponUserId", void 0);
tslib_1.__decorate([
    Prop()
], CouponListPopup.prototype, "from", void 0);
tslib_1.__decorate([
    Prop({ default: () => { } })
], CouponListPopup.prototype, "uploadEvent", void 0);
tslib_1.__decorate([
    Prop({ default: () => { } })
], CouponListPopup.prototype, "uploadParmas", void 0);
tslib_1.__decorate([
    Prop({ default: { spuId: 0 } })
], CouponListPopup.prototype, "product", void 0);
CouponListPopup = tslib_1.__decorate([
    Component({
        filters: {
            couponType: type => {
                return {
                    all: '通用券',
                    designation: '商品券',
                }[type];
            },
            thresholdPrice: num => {
                const number = +num;
                return number ? `满¥${number.toFixed(2)}` : '无门槛';
            },
            number2Fixed: num => {
                const number = +num;
                return number ? `${number.toFixed(2)}` : '0.00';
            },
        },
    })
], CouponListPopup);
export default CouponListPopup;
